import Reflux from 'reflux';
import TeamData from 'shared/data/Team';

let async = { asyncResult: true },
  LabelEditFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    update: async,
    populate: {},
    clear: {},
  });

LabelEditFormActions.update.listenAndPromise(TeamData.updateLabel);

export default LabelEditFormActions;
